'use client';
import React, { ReactElement } from 'react';
import Image from 'next/image';
import LouiseButton, { CtaTargetType } from '@/components/buttons/LouiseButton';
import ReactHtmlParser from 'react-html-parser';

type Props = {
  badge?: string;
  badgeIcon?: ReactElement;
  title: string;
  description: string;
  btnColor: 'blue' | 'white' | 'gray' | 'red' | 'green' | 'transparent';
  cta: string;
  image: string;
  link: 'plan' | 'register';
  locale: string;
};

const BlockDescriptionImageRight = ({
  badge,
  badgeIcon,
  title,
  description,
  btnColor,
  cta,
  image,
  link,
  locale,
}: Props) => {
  return (
    <section className="tw-pt-10 lg:tw-pt-24 tw-bg-transparent">
      <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-max-w-7xl">
        <div className="tw-space-y-32">
          <div className="tw-grid lg:tw-grid-cols-2 tw-gap-16 tw-items-center">
            <div className="tw-space-y-8">
              {badge && (
                <div className="tw-inline-flex tw-items-center tw-gap-2 tw-bg-blue-100 tw-text-blue-700 tw-px-4 tw-py-2 tw-rounded-full tw-text-sm tw-font-medium">
                  {badgeIcon}
                  {badge}
                </div>
              )}

              <h2 className="tw-text-3xl lg:tw-text-4xl xl:tw-text-5xl tw-font-bold tw-text-gray-900 tw-leading-tight">
                {title}
              </h2>
              <p className="tw-text-base tw-text-gray-600 tw-leading-relaxed">{ReactHtmlParser(description)}</p>
              {link === 'plan' ? (
                <LouiseButton color={btnColor} cta={cta} ctaTarget="plans" animation={true} locale={locale} />
              ) : (
                <LouiseButton color={btnColor} cta={cta} ctaTarget="register" animation={true} locale={locale} />
              )}
            </div>
            <div className="tw-relative">
              <Image
                className="tw-w-full tw-h-auto tw-rounded-3xl tw-shadow-2xl"
                priority
                quality={100}
                alt={title}
                src={image}
                width={600}
                height={500}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlockDescriptionImageRight;
